module.exports = __webpack_public_path__ + "static/media/why-us_hk0luy.9815f0be.jpg";